import { QueryClient, QueryFilters } from "@tanstack/react-query";

import { OurUseQueryOptions } from "@nens/react-query-utils";

export type QueryDirectlyReturn<T> = Promise<
  | { isError: true; isSuccess: false; data: undefined; error: unknown }
  | { isError: false; isSuccess: true; data: T; error: undefined }
>;

// Hook to execute a React Query hook manually and cache the result (used when you need a query result for a one-time action, like downloading a file)
export const queryDirectly = async <T>(
  queryClient: QueryClient,
  query: OurUseQueryOptions<T>,
  filters?: QueryFilters
): QueryDirectlyReturn<T> => {
  try {
    // Try to find an existing query that matches the key and filters if there are filters provided
    const existingQuery = filters
      ? queryClient.getQueryCache().find({
          queryKey: query.queryKey,
          ...filters,
        })
      : undefined;

    const data = await queryClient.ensureQueryData<T>({
      queryKey: query.queryKey,
      queryFn: query.queryFn,
      ...existingQuery,
    });

    return { isError: false, isSuccess: true, error: undefined, data };
  } catch (error) {
    console.error(error);

    return {
      isError: true,
      isSuccess: false,
      error,
      data: undefined,
    };
  }
};
